import React from 'react';
import '../less/childrens.less';
import hero_img from '../img/hero_img.png';
import CardOrderModal from './../../../../auxiliary-components/CardOrderModal';
import Hero from './../../../../auxiliary-components/shared/HeroBlock';
import { tariffsKidCard } from '../../../../services/urls/urls';
import Tabs from './../../../../auxiliary-components/shared/Tabs';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import QuestionsAdminNew from './../../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "./../../../../auxiliary-components/shared/FilesForDownloadNew";
import Tariffs from './../../../../auxiliary-components/shared/TariffsBlock';
import HowToBlockNew from './../../../../auxiliary-components/shared/HowToBlockNew';
import FAQStorybook from '@abank/abank-faq';
import tariffsData from '../enums/tariffs_data.json';
import { filterByEnvironment } from '../../../../helpers/utils/environmentFilter';

export default function template() {
  const page = 'kid-card-new';

  const tabs = [{tab: 'tariffs', title: 'KID_CARD_NEW_TABS_INFO_TITLE_01'},
        {tab: 'how-to', title: 'KID_CARD_NEW_TABS_INFO_TITLE_02'}];

  const hero_data = {
    title: 'KID_CARD_NEW_HERO_TITLE',
    text: 'KID_CARD_NEW_HERO_TEXT',
    link: {
      text: "KID_CARD_NEW_HERO_BTN",
      onClick: () => this.toggleModal(),
    },
    cards: [
      {
        title: 'KID_CARD_NEW_CARDS_HERO_TITLE_01',
        text: 'KID_CARD_NEW_CARDS_HERO_TEXT_01',
      },
      {
        title: 'KID_CARD_NEW_CARDS_HERO_TITLE_02',
        text: 'KID_CARD_NEW_CARDS_HERO_TEXT_02',
      },
      {
        title: 'KID_CARD_NEW_CARDS_HERO_TITLE_03',
        text: 'KID_CARD_NEW_CARDS_HERO_TEXT_03',
      }
    ]
  };

  const howToBlockItems = [
    {
      img: how_to_block_img_1,
      title: 'KID_CARD_NEW_HOW_TO_TITLE_01',
      text: 'KID_CARD_NEW_HOW_TO_TEXT_01',
    },
    {
      img: how_to_block_img_2,
      title: 'KID_CARD_NEW_HOW_TO_TITLE_02',
      text: 'KID_CARD_NEW_HOW_TO_TEXT_02',
    },
    {
      img: how_to_block_img_3,
      title: 'KID_CARD_NEW_HOW_TO_TITLE_03',
      text: 'KID_CARD_NEW_HOW_TO_TEXT_03',
    }
  ];

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="kid-card-new">
      <Hero
        data={hero_data}
        img={hero_img}
        page={page}
      />
      <div className="content">
        {!this.state.faqTab ? (
          <>
            <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
              <Tariffs
                items={tariffsData}
                title={'KID_CARD_NEW_CARDS_TARIFFS_TITLE'}
                btnLink={tariffsKidCard}
                btnText={'KID_CARD_NEW_CARDS_TARIFFS_BTN'}
                page={page}
              />
              <HowToBlockNew
                title={'KID_CARD_NEW_HOW_TO_TITLE'}
                items={howToBlockItems}
              />
            </Tabs>
            <QuestionsAdminNew
              title={'KID_CARD_NEW_FAQ_STORYBOOK_TITLE'}
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              page={page}
            />
            <FilesForDownloadNew
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
            />
          </>
        ) : (
          <FAQStorybook
            widget={questionsWidget}
            title={this.l10n('KID_CARD_NEW_FAQ_STORYBOOK_TITLE')}
            btnText={this.l10n('KID_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
            onBtnClick={this.toggleFaqTab}
            filterByEnvironment={filterByEnvironment}
          />
        )}
      </div>
      {this.state.showModal ? 
        <CardOrderModal closeModal={this.toggleModal} product={"kid"} isOpen={this.state.showModal} forceMode="utm"/> : ''
      }
    </div>
  );
}
